// src/layouts/commissions/data/commissionsTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import Swal from "sweetalert2";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));

export default function commissionsTableData(commissions, handleEditClick, fetchCommissions) {
  const handleDeletion = async (commission) => {
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: `سيتم حذف العمولة رقم "${commission.id}" بشكل دائم!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const token = localStorage.getItem("user-token");
          const response = await axios.delete(
            `https://back.al-balad.sa/albalad/v1.0/administrator/commissions/${commission.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          Swal.showValidationMessage(
            `فشل الحذف: ${error.response?.data?.message || error.message}`
          );
          return false;
        }
      },
    });

    if (result.isConfirmed) {
      if (result.value?.status) {
        Swal.fire({
          icon: "success",
          title: "تم الحذف!",
          text: "تم حذف العمولة بنجاح",
        });
        fetchCommissions();
      } else {
        Swal.fire({
          title: "فشل الحذف!",
          text: result.value?.message || "حدث خطأ غير متوقع",
          icon: "error",
        });
      }
    }
  };

  const handleActivation = async (commission) => {
    try {
      const token = localStorage.getItem("user-token");
      const response = await axios.patch(
        `https://back.al-balad.sa/albalad/v1.0/administrator/commissions/${commission.id}/toggle-paid`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "تم التحديث!",
          text: "تم تغيير حالة الدفع بنجاح",
        });
        fetchCommissions();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "فشل التحديث!",
        text: error.response?.data?.message || "حدث خطأ أثناء التحديث",
      });
    }
  };

  const Status = ({ isPaid }) => (
    <MDBox ml={-1}>
      <MDBadge
        badgeContent={isPaid ? "مدفوع" : "غير مدفوع"}
        color={isPaid ? "success" : "warning"}
        variant="gradient"
        size="sm"
      />
    </MDBox>
  );

  return {
    columns: [
      { Header: "المعرف", accessor: "id", width: "10%", align: "right" },
      { Header: "المبلغ الأساسي", accessor: "base_amount", align: "right" },
      { Header: "العمولة", accessor: "calculated_commission", align: "right" },
      { Header: "إجمالي الطلب", accessor: "order_total", align: "right" },
      { Header: "التاريخ", accessor: "created_at", align: "right" },
      { Header: "حالة الدفع", accessor: "status", align: "center" },
      { Header: "الإجراءات", accessor: "action", align: "center" },
    ],

    rows: commissions.map((commission) => ({
      id: (
        <MDTypography variant="button" fontWeight="medium">
          {commission.id}
        </MDTypography>
      ),
      base_amount: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {commission.base_amount || "---"}
        </MDTypography>
      ),
      calculated_commission: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {commission.calculated_commission || "---"}
        </MDTypography>
      ),
      order_total: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {commission.order?.total || "غير متوفر"}
        </MDTypography>
      ),
      created_at: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {commission.created_at
            ? new Date(commission.created_at).toLocaleDateString("ar-EG")
            : "---"}
        </MDTypography>
      ),
      status: <Status isPaid={commission.is_paid} />,
      action: (
        <MDBox
          display="flex"
          alignItems="center"
          gap={1}
          p={1}
          borderRadius="lg"
          bgcolor="background.paper"
          boxShadow={1}
        >
          <CustomSwitch
            checked={Boolean(commission.is_paid)}
            onChange={() => handleActivation(commission)}
            color="default"
          />

          <IconButton
            aria-label="edit"
            sx={{
              color: "info.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleEditClick(commission)}
          >
            <EditIcon fontSize="medium" />
          </IconButton>

          <IconButton
            aria-label="delete"
            sx={{
              color: "error.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleDeletion(commission)}
          >
            <DeleteIcon fontSize="medium" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
